import React from 'react';
import { I18nextProvider } from 'react-i18next';

export default function TranslationProvider({ children, i18n }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
